<!-- Поле рукописной подписи с pointer events и выдачей прозрачного PNG Blob. -->
<template>
  <div class="base-signature-pad">
    <canvas
      ref="canvas"
      class="base-signature-pad__canvas"
      aria-label="Поле для подписи"
      @pointerdown="startDrawing"
      @pointermove="draw"
      @pointerup="stopDrawing"
      @pointercancel="stopDrawing"
      @pointerleave="stopDrawing"
    ></canvas>
    <base-button type="button" variant="ghost" icon="trash" @click="clear">
      Стереть
    </base-button>
  </div>
</template>

<script>
export default {
  name: "BaseSignaturePad",

  emits: ["change"],

  data() {
    return {
      drawing: false,
      hasInk: false,
      resizeObserver: null,
    };
  },

  methods: {
    resizeCanvas() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      const hadInk = this.hasInk;
      const previousWidth = canvas.width;
      const previousHeight = canvas.height;
      let snapshot = null;
      if (hadInk && previousWidth && previousHeight) {
        snapshot = document.createElement("canvas");
        snapshot.width = previousWidth;
        snapshot.height = previousHeight;
        snapshot.getContext("2d").drawImage(canvas, 0, 0);
      }
      const rectangle = canvas.getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.round(rectangle.width * ratio));
      canvas.height = Math.max(1, Math.round(rectangle.height * ratio));
      const context = canvas.getContext("2d");
      context.scale(ratio, ratio);
      context.lineWidth = 2.4;
      context.lineCap = "round";
      context.lineJoin = "round";
      // Canvas не разрешает CSS-переменные в strokeStyle, поэтому берём вычисленный цвет компонента.
      context.strokeStyle = window.getComputedStyle(canvas).color;
      if (snapshot) {
        context.drawImage(
          snapshot,
          0,
          0,
          previousWidth,
          previousHeight,
          0,
          0,
          rectangle.width,
          rectangle.height
        );
      }
      this.hasInk = hadInk;
    },

    point(event) {
      const rectangle = this.$refs.canvas.getBoundingClientRect();
      return { x: event.clientX - rectangle.left, y: event.clientY - rectangle.top };
    },

    startDrawing(event) {
      event.preventDefault();
      this.drawing = true;
      this.$refs.canvas.setPointerCapture?.(event.pointerId);
      const { x, y } = this.point(event);
      const context = this.$refs.canvas.getContext("2d");
      context.beginPath();
      context.moveTo(x, y);
    },

    draw(event) {
      if (!this.drawing) return;
      event.preventDefault();
      const { x, y } = this.point(event);
      const context = this.$refs.canvas.getContext("2d");
      context.lineTo(x, y);
      context.stroke();
      this.hasInk = true;
    },

    stopDrawing() {
      if (!this.drawing) return;
      this.drawing = false;
      this.$emit("change", this.hasInk);
    },

    clear() {
      const canvas = this.$refs.canvas;
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
      this.hasInk = false;
      this.$emit("change", false);
    },

    getBlob() {
      if (!this.hasInk) return Promise.resolve(null);
      return new Promise((resolve) => this.$refs.canvas.toBlob(resolve, "image/png"));
    },
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(this.resizeCanvas);
    this.resizeObserver.observe(this.$refs.canvas);
    this.resizeCanvas();
  },

  beforeUnmount() {
    this.resizeObserver?.disconnect();
  },
};
</script>

<style scoped>
.base-signature-pad {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.base-signature-pad__canvas {
  width: 100%;
  height: 240px;
  border: 1px solid var(--color-grey);
  border-radius: 10px;
  background: var(--color-light);
  color: var(--color-dark);
  touch-action: none;
  cursor: crosshair;
}

@media (max-width: 420px) {
  .base-signature-pad__canvas {
    height: 220px;
  }
}
</style>
